<template>
  <MdtModal
    :title="'general_contact_request' | translate"
    width="510px"
    :button-text="'general_send' | translate"
    :button-disabled="loading"
    @close="$emit('close')"
    @cancel="$emit('close')"
    @save="send">
    <MdtLoader v-if="loading" />
    <template v-else>
      <MdtSelect
        ref="title"
        v-model="form.title"
        class="form-row"
        :label="'general_salutation' | translate"
        :options="salutationChoices"
        required />
      <MdtInput
        ref="firstname"
        v-model="form.firstname"
        class="form-row"
        :label="'general_first_name' | translate"
        required />
      <MdtInput
        ref="name"
        v-model="form.name"
        class="form-row"
        :label="'general_last_name' | translate"
        required />
      <MdtInput
        ref="email"
        v-model="form.email"
        class="form-row"
        :label="'general_email' | translate"
        type="email"
        required />
      <MdtPhoneNumberInput
        v-model="form.phone"
        class="form-row"
        :label="'general_phone' | translate" />
      <MdtTextarea
        v-model="form.remarks"
        class="form-row"
        :label="'general_comment' | translate" />
    </template>
  </MdtModal>
</template>

<script>
export default {
  name: 'ModalPublicContactForm',
  props: {
    salutationChoices: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      form: {
        title: '', // Salutation
        firstname: '',
        name: '', // Last name
        email: '',
        phone: '',
        remarks: '',
        object_select: Number(this.$route.params.id),
        data_protection: true, // Harcoded, because it's required on backend
      },
      loading: false,
    };
  },
  methods: {
    send() {
      if (!this.isValid()) return;

      this.loading = true;
      this.$store.dispatch('publicObjectList/postObjectContactForm', this.form)
        .then((data) => {
          this.$store.dispatch('notify', data.notify);
          this.$emit('close');
          this.$emit('requestSent');
        }).catch(this.showResponseError).finally(() => {
          this.loading = false;
        });
    },
    isValid() {
      return Object.values(this.$refs).map((r) => r.isValid()).every((r) => r);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-row {
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
